import React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { TextInput } from "../components/TextInput";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import Link from '@material-ui/core/Link';
import { LOGIN, TERMS, PRIVACY_POLICY } from '../utils/routes'
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%',
    margin: theme.spacing(1),
    marginBottom: theme.spacing(3)
  },
  errorMessage: {
    color: 'red'
  },
  button: {
    position: 'relative'
  },
  progress: {
    position: 'absolute',
    color: 'white'
  },
  loginLogo: {
    width: '100%'
  },
  centerLoginForm: {
    position: 'absolute',
    width: theme.sizes.loginFormWidth,
    left: `calc(50% - ${theme.sizes.loginFormWidth / 2}px)`
  },
  signUpLink: {
    textDecoration: "underline"
  },
  loginLink: {
    textDecoration: "underline"
  },
  padded: {
    padding: theme.spacing(1)
  }
}));

export default function SignUpForm({
  onSubmit,
  email,
  onEmailChange,
  pass,
  onPassChange,
  passConfirm,
  onPassConfirmChange,
  passDoNotMatch,
  orgName,
  onOrgNameChange,
  betaKey,
  onBetaKeyChange,
  terms,
  onTermsChange,
  saveAvaliable,
  loading,
  errorMessage
}) {
  const classes = useStyles();

  return (
    <Container component='main' maxWidth='xs' className={classes.centerLoginForm}>
      <CssBaseline />
      <div className={classes.paper}>
        <img src="/loginLogo.png" className={classes.loginLogo} />
        <div className={classes.form}>
          <TextInput
            required
            label='Email Address'
            type='email'
            value={email}
            onChange={onEmailChange}
            variant='outlined'
            autoFocus
          />
          <TextInput
            required
            label='Password'
            type='password'
            value={pass}
            onChange={onPassChange}
            variant='outlined'
          />
          <TextInput
            required
            label='Password Confirm'
            type='password'
            value={passConfirm}
            onChange={onPassConfirmChange}
            error={passDoNotMatch}
            variant='outlined'
          />
          <TextInput
            required
            label='Organization Name'
            value={orgName}
            onChange={onOrgNameChange}
            variant='outlined'
          />
          <TextInput
            required
            label='Beta Key'
            value={betaKey}
            onChange={onBetaKeyChange}
            variant='outlined'
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={terms}
                onChange={event => onTermsChange(event.target.checked)}
                color="primary"
              />
            }
            label={
              <div className={classes.padded}>
                I understand this is a beta product and I agree to the{"\u00A0"}
                <Link href={TERMS} className={classes.loginLink} target="_blank">
                  Terms of Service
                </Link> and&nbsp;
                <Link href={PRIVACY_POLICY} className={classes.loginLink} target="_blank">
                  Privacy Policy
                </Link>
              </ div>
            }
          />

          <Button type='submit' fullWidth className={classes.button} variant='contained' color='primary' disabled={!saveAvaliable} onClick={onSubmit}>
            Sign Up
            {loading && <CircularProgress className={classes.progress} size={30} />}
          </Button>
          <Typography className={classes.errorMessage} align='center'>
            {errorMessage}
          </Typography>
        </div>
        <Typography>
          <Link href={LOGIN} className={classes.loginLink}>
            Already have an account? Sign in
            </Link>
        </Typography>
      </div>
    </Container>
  );
}
